import Cookies from 'js-cookie';
import LogRocket from 'logrocket';
export const API_URL =
    typeof window !== 'undefined' && window.location.hostname === 'app.clientbloom.ai'
        ? 'https://api.clientbloom.ai'
        : 'https://api-staging.clientbloom.ai';

export const generateCSRFToken = (length = 32) => {
    const array = new Uint8Array(length);
    if (!window.crypto) {
        throw new Error('Crypto API not available. This feature requires a secure context (HTTPS). Please ensure you are accessing the application over HTTPS and using a modern browser.');
    }
    window.crypto.getRandomValues(array);
    return Array.from(array, b => b.toString(16).padStart(2, '0')).join('');
}

const storeSession = ({ token, user }) => {
    Cookies.set('token', token, { expires: 190 });
    Cookies.set('user', JSON.stringify(user), { expires: 7 });

    if (user.workspace_id) {
        Cookies.set('workspaceId', user.workspace_id, { expires: 7 });
    }

    // LogRocket user tracking
    LogRocket.identify(user.id || user.email, { id: user.id, email: user.email });
};
const Auth = {
    login: async (email, password) => {
        try {
            const response = await fetch(`${API_URL}/auth/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password }),
            });

            const data = await response.json();

            if (response.ok) {
                storeSession(data);
                return { success: true, user: data.user };
            } else {
                return { success: false, message: data.message || 'Login failed' };
            }
        } catch (error) {
            return { success: false, message: 'Something went wrong' };
        }
    },
    adminLogin: async (email, password) => {
        try {
            const response = await fetch(`${API_URL}/auth/admin-login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password }),
            });
            const data = await response.json();

            if (response.ok) {
                storeSession(data);

                return { success: true, user: data.user };
            }
            return { success: false, message: data.message || 'Admin login failed' };
        } catch (err) {
            return { success: false, message: 'Something went wrong' };
        }
    },
    register: async (email, password, phone, workspace_name) => {
        try {
            const response = await fetch(`${API_URL}/auth/register`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password, phone_number: phone, workspace_name }),
            });

            const data = await response.json();

            if (response.ok) {
                Cookies.set('token', data.token, { expires: 190 });

                Cookies.set('user', JSON.stringify(data.user), { expires: 7 });

                if (data.user.workspace_id) {
                    Cookies.set('workspaceId', data.user.workspace_id, { expires: 7 });
                }

                return { success: true, user: data.user };
            } else {
                return { success: false, message: data.message || 'Registration failed' };
            }
        } catch (error) {
            return { success: false, message: 'Something went wrong' };
        }
    },

    logout: () => {
        Cookies.remove('token');
        Cookies.remove('user');
        Cookies.remove('workspaceId');
        localStorage.removeItem('passwordModalShown');
        sessionStorage.clear();
        window.location.href = '/login';
    },

    getToken: () => Cookies.get('token'),

    getUser: () => {
        const user = Cookies.get('user');
        return user ? JSON.parse(user) : null;
    },

    setUser: (user) => {
        Cookies.set('user', JSON.stringify(user), { expires: 7 });
    },

    getWorkspaceId: () => {
        const user = Cookies.get('user');
        if (!user) return null;

        try {
            const parsedUser = JSON.parse(user);
            return parsedUser.workspace_id || null;
        } catch {
            return null;
        }
    },

    isAuthenticated: async () => {
        const token = Cookies.get('token');
        if (!token) return false;

        try {
            const response = await fetch(`${API_URL}/auth/verify`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token }),
            });

            const data = await response.json();

            if (response.ok && data.message === 'verified') {
                return true;
            }
            return false;
        } catch (error) {
            return false;
        }
    }
};

export default Auth;

